import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { GeneralMessageDialogSetting } from 'src/app/models/general-message-dialog-setting';
import { MatButtonModule } from '@angular/material/button';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'confirm-message-dialog.component',
  templateUrl: './confirm-message-dialog.component.html',
  styleUrls: ['./confirm-message-dialog.component.scss'],
  imports: [MatDialogModule, MatButtonModule],
})
export class ConfirmMessageDialogComponent {
  dialog = inject(MatDialog);
  dialogRef = inject<MatDialogRef<ConfirmMessageDialogComponent>>(MatDialogRef);
  data = inject<GeneralMessageDialogSetting>(MAT_DIALOG_DATA);


  close(btnValue: any): void {
    this.data.ReturnValue = btnValue;
    this.dialogRef.close(this.data);
  }
}
